"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
exports.useStyles = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        backDrop: {
            background: 'rgba(0,0,0,0)',
        },
        backDrop2: {},
        styleIcons: {
            fontSize: 40,
            color: "#141B4D",
        },
        messageBox: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 220,
            minWidth: 496,
        },
        backgroundContainerMessageBox: {
            backgroundColor: "#E2E6F3",
            boxShadow: ' 0px 0px 18px rgba(58, 79, 135, 0.3)',
            borderRadius: 8,
            '&: hover': {
                border: "none"
            }
        },
        backgroundTopMessageBox: {
            backgroundColor: "#fff",
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            height: 44,
            textAlign: "center",
        },
        textTitleMessageBox: {
            fontSize: 16,
            fontFamily: "Inter",
            color: '#2B304F',
            fontWeight: 600,
            paddingTop: 10,
        },
        contentMidContainerMessageBox: {
            justifyContent: "center",
            paddingRight: 40,
            paddingLeft: 40,
            paddingTop: 44
        },
        contentCommandContainerMessageBox: {
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
            paddingTop: 44
        },
        paddingTypographyMessageBox: {
            padding: 10,
            fontFamily: "Inter",
            fontSize: 14,
            textAlign: 'start'
        },
        paddingTypographyMessageBoxNoICon: {
            padding: 10,
            fontFamily: "Inter",
            fontSize: 14,
            textAlign: 'center'
        },
        directionIcon: {
            textAlign: 'center'
        },
        buttonOkAlone: {
            backgroundColor: "#fff",
            color: "#141B4D",
            border: "1px solid #898DA6",
            fontWeight: 600,
            fontFamily: "Inter",
            textTransform: 'none',
            fontSize: 14,
            width: 89,
            borderRadius: 4,
            marginBottom: 16,
        },
        buttonOk: {
            backgroundColor: "#fff",
            color: "#141B4D",
            border: "1px solid #898DA6",
            fontWeight: 600,
            fontFamily: "Inter",
            marginRight: 10,
            textTransform: 'none',
            fontSize: 14,
            width: 89,
            marginBottom: 16,
            borderRadius: 4,
        },
        buttonCancelar: {
            backgroundColor: "#C0A8BD",
            color: "#141B4D",
            border: "1px solid #898DA6",
            fontWeight: 600,
            fontFamily: "Inter",
            marginLeft: 10,
            textTransform: 'none',
            fontSize: 14,
            width: 89,
            marginBottom: 16,
            borderRadius: 4,
        },
        buttonSim: {
            backgroundColor: "#fff",
            color: "#141B4D",
            border: "1px solid #898DA6",
            fontWeight: 600,
            fontFamily: "Inter",
            marginRight: 10,
            textTransform: 'none',
            fontSize: 14,
            width: 89,
            marginBottom: 16,
            borderRadius: 4,
        },
        buttonNão: {
            backgroundColor: "#B8CCEA",
            color: "#141B4D",
            border: "1px solid #898DA6",
            fontWeight: 600,
            fontFamily: "Inter",
            marginRight: 10,
            textTransform: 'none',
            fontSize: 14,
            width: 89,
            marginBottom: 16,
            borderRadius: 4,
        },
        buttonNão2: {
            backgroundColor: "#B8CCEA",
            color: "#141B4D",
            border: "1px solid #898DA6",
            fontWeight: 600,
            fontFamily: "Inter",
            marginRight: 10,
            marginLeft: 10,
            textTransform: 'none',
            fontSize: 14,
            width: 89,
            marginBottom: 16,
            borderRadius: 4,
        },
        /* Dialog --------------------------- */
        dialog: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 492,
            minWidth: 880
        },
        backgroundContainerDialog: {
            backgroundColor: "#E2E6F3",
            boxShadow: ' 0px 0px 18px rgba(58, 79, 135, 0.3)',
            borderRadius: 8,
        },
        backgroundTopDialog: {
            backgroundColor: "#fff",
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            paddingTop: 20,
            paddingBottom: 20,
            paddingRight: 24,
            paddingLeft: 24,
            height: 72,
            justifyContent: 'space-between',
            alignContent: 'center',
            alignItems: 'center',
        },
        textTitleDialog: {
            fontSize: 26,
            fontFamily: "Inter",
            color: '#2B304F',
            fontWeight: 200,
        },
        contentMidContainerDialogIcon: {
            padding: 40
        },
        contentMidContainerDialog: {
            justifyContent: "center",
            padding: 40,
        },
        paddingTypographyDialog: {
            padding: 10,
            fontFamily: "Inter",
            fontSize: 14,
        },
        paddingTypographyDialogIcon: {
            padding: 10,
            fontFamily: "Inter",
            fontSize: 14,
            textAlign: 'left'
        },
        headerMessage: {
            backgroundColor: 'white',
            height: 24,
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            padding: 20,
        },
        headerDialog: {
            backgroundColor: 'white',
            height: 52,
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
        },
        titleDialog: {
            fontSize: 16,
            fontFamily: "Inter",
            color: '#2B304F',
            fontWeight: 600,
            justifyContent: 'center'
        },
        titleMessage: {
            fontSize: 26,
            fontFamily: "Inter",
            color: '#2B304F',
            fontWeight: 200,
            justifyContent: 'center'
        },
    });
});
